<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss" >
 @import "./style/reset.css";
body{
  margin: 0;
  padding:0;
  overflow: hidden;
}
*{
  -webkit-tap-highlight-color: transparent;
}
img{
  cursor: pointer;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.van-toast{
  top:20%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue